import React, { useEffect, useState } from "react";
import { TreeViewArrayFromMap } from "./tree-view-array-from-map";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { BlueprintBannerFlexWrapper } from "@src/components/organisms/blueprint-banner-wrapper/blueprint-banner-flex-wrapper";
import { SmallBluePrintBannerAutoMatch } from "@src/components/organisms/small-blueprint-banner-auto-match/small-blueprint-banner-auto-match";
import { calcContentPaneHeight } from "@src/cloud-connect/utils/calculate-content-pane-height";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { RenderIfUserHasMultiplePermissions } from "@src/components/molecules/render-if-user-has-multiple-permissions/render-if-user-has-multiple-permissions";

export const TreeViewMachineStructureFlatMap = () => {
  const machineStructureNodeset = getMachineStructureNodeset();

  const transferedNodeData = useSelector(
    (state: RootState) => state.yourSlice.editStructurePageTransferData,
  );

  const [flatArray, setFlatArray] = useState(
    Array.from(
      machineStructureNodeset.getFlatMap()
        ? machineStructureNodeset.getFlatMap().values()
        : [],
    ),
  );

  useEffect(() => {
    const updateFlatMap = () => {
      const newFlatMap = machineStructureNodeset.getFlatMap();
      setFlatArray(Array.from(newFlatMap ? newFlatMap.values() : []));
    };

    machineStructureNodeset.addObserver(updateFlatMap);

    return () => {
      machineStructureNodeset.removeObserver(updateFlatMap);
    };
  }, [machineStructureNodeset]);

  return (
    <>
      <div
        style={{
          height: calcContentPaneHeight(397),
          overflowY: transferedNodeData ? "scroll" : "hidden",
          overflowX: "hidden",
        }}
      >
        <RenderIfUserHasMultiplePermissions
          permissions={["manage-blueprints", "view-blueprints"]}
        >
          <BlueprintBannerFlexWrapper>
            <SmallBluePrintBannerAutoMatch />
          </BlueprintBannerFlexWrapper>
        </RenderIfUserHasMultiplePermissions>

        {flatArray && flatArray.length > 0 && (
          <TreeViewArrayFromMap data={flatArray} type="machine" />
        )}
      </div>
    </>
  );
};
